"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var __1 = require("..");
var PhoneEmailVerifyContent_1 = __importDefault(require("./PhoneEmailVerifyContent"));
var PhoneEmailVerifyLayout_1 = __importDefault(require("./PhoneEmailVerifyLayout"));
var PhoneEmailVerification = function (_a) {
    var channel = _a.channel, override = _a.override, requiresPageLayout = _a.requiresPageLayout, disableDismiss = _a.disableDismiss;
    return (React.createElement(PhoneEmailVerifyLayout_1["default"], { disableDismiss: disableDismiss, requiresPageLayout: requiresPageLayout },
        React.createElement(__1.VerifyAccountProvider, { blockChannelSwitch: true, channel: channel, override: override },
            React.createElement(PhoneEmailVerifyContent_1["default"], null))));
};
exports["default"] = PhoneEmailVerification;
